import React from 'react';

const EmoticonCoolIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <path
      d='M23 14c0 1.38-2.12 2.5-3.5 2.5s-2.75-1.12-2.75-2.5h-1.5c0 1.38-1.37 2.5-2.75 2.5S9 15.38 9 14h-.75c-.16.64-.25 1.31-.25 2a8 8 0 1 0 16 0c0-.69-.09-1.36-.25-2H23m-7-6c-2.96 0-5.55 1.61-6.93 4h13.86C21.55 9.61 18.96 8 16 8m10 8c0 5.523-4.477 10-10 10a10 10 0 1 1 10-10m-10 5.23c-1.75 0-3.29-.73-4.19-1.81L13.23 18c.45.72 1.52 1.23 2.77 1.23s2.32-.51 2.77-1.23l1.42 1.42c-.9 1.08-2.44 1.81-4.19 1.81z'
      fill='currentColor'
      fillRule='nonzero'
    />
  </svg>
);

export default EmoticonCoolIcon;
